import MainDashboardView from '@Dashboard/views/index.vue';
import AIInspectDashboardView from '@Dashboard/views/AIInspect.vue';
import InspectionDashboardView from '@Dashboard/views/Inspection.vue';
import RBIDashboardView from '@Dashboard/views/RBI.vue';
import ThicknessDashboardView from '@Dashboard/views/ThicknessNew.vue';
import CathodicView from '@Dashboard/views/Cathodic.vue';
import IOWsView from '@Dashboard/views/IOWs.vue';
import CustomDashboard from './views/CustomDashboard.vue';
import CorrosionAnalyserView from '@Dashboard/views/CorrosionAnalyser.vue';
import CoatingAnalyzer from './views/CoatingAnalyzer.vue';
import AIAnalysisView from '@Dashboard/views/AIAnalysis.vue';
import AIAnalysisReportView from '@Dashboard/views/AIAnalysisReport.vue';
import permissions from '../Share/config/permissions';
import { log as debugLog } from '@/utils/debugLogger';

// The custom-dashboard route carries CustomDashboards.View permission meta.
debugLog(
	`[dashboard.routes] custom-dashboard route permission meta applied (CustomDashboards.View)`
);

export default [
	{
		path: '/:id/dashboard/inspection',
		component: MainDashboardView,
		meta: {
			requiresAuth: true,
			facilityScope: true,
			layout: 'viewer-layout',
		},
		children: [
			{
				path: 'inspection',
				name: 'inspection',
				component: InspectionDashboardView,
				meta: {
					requiresAuth: true,
					title: 'Inspection',
					layout: 'viewer-layout',
					// permissions: [permissions.InspectionDashboard.View],
				},
			},
			{
				path: 'rbi',
				name: 'rbi',
				component: RBIDashboardView,
				meta: {
					requiresAuth: true,
					title: 'RBI',
					layout: 'viewer-layout',
					// permissions: [permissions.RBIDashboard.View],
				},
			},
			{
				path: 'thickness',
				name: 'thickness',
				component: ThicknessDashboardView,
				meta: {
					requiresAuth: true,
					title: 'Thickness',
					layout: 'viewer-layout',
					// permissions: [permissions.ThicknessDashboard.View],
				},
			},
			{
				path: 'ai-inspect',
				name: 'ai-inspect',
				component: AIInspectDashboardView,
				meta: {
					requiresAuth: true,
					title: 'AI Inspect',
					layout: 'viewer-layout',
					// permissions: [permissions.AIInspectDashboard.View],
				},
			},
			{
				path: 'corrosion-analyser',
				name: 'corrosion-analyser',
				component: CorrosionAnalyserView,
				meta: {
					requiresAuth: true,
					title: 'Corrosion Analyser',
					layout: 'viewer-layout',
					// permissions: [permissions.CorrosionAnalyser.View],
				},
			},
			{
				path: 'coating-analyser',
				name: 'coating-analyser',
				component: CoatingAnalyzer,
				meta: {
					requiresAuth: true,
					title: 'Coating Analyzer',
					layout: 'viewer-layout',
					// permissions: [permissions.CorrosionAnalyser.View],
				},
			},
			{
				path: 'ai-analysis',
				name: 'ai-analysis',
				component: AIAnalysisView,
				meta: {
					requiresAuth: true,
					title: 'AI Analysis',
					layout: 'viewer-layout',
					// Dedicated permission is API ask 9; the tab reuses Inspections_AIInspect until it is seeded.
				},
			},
			{
				path: 'ai-analysis/:jobId',
				name: 'ai-analysis-job',
				component: AIAnalysisReportView,
				meta: {
					requiresAuth: true,
					title: 'AI Analysis Report',
					layout: 'viewer-layout',
				},
			},
			{
				path: '',
				name: 'default',
				component: AIInspectDashboardView,
				meta: {
					requiresAuth: true,
					title: 'AI Inspect',
					layout: 'viewer-layout',
					// permissions: [permissions.AIInspectDashboard.View],
				}
			},
			{
				path: 'cathodic',
				name: 'cathodic',
				component: CathodicView,
				meta: {
					requiresAuth: true,
					title: 'Cathodic',
					layout: 'viewer-layout',
					// permissions: [permissions.ThicknessDashboard.View],
				},
			},
			{
				path: 'iows',
				name: 'iows',
				component: IOWsView,
				meta: {
					requiresAuth: true,
					title: 'IOWs',
					layout: 'viewer-layout',
					// permissions: [permissions.ThicknessDashboard.View],
				},
			},
		]
	},
	{
		path: '/:id/dashboard/custom',
		component: CustomDashboard,
		name: 'custom-dashboard',
		meta: {
			requiresAuth: true,
			facilityScope: true,
			title: 'Custom Dashboards',
			layout: 'viewer-layout',
			permissions: [permissions.CustomDashboards.View]
		}
	}
]